import { SliceType } from 'components/MCTextEditor/slice/types'
import { IProcessorState, ISlice } from 'components/RichTextEditor/processor/constants'
import { sliceArraysEqual } from 'components/RichTextEditor/processor/helpers'
import * as textProcessorSelectors from 'components/RichTextEditor/processor/selectors/textProcessorSelectors'

import { exportSlice } from './exportSlice'

const sliceOrderDefault = 10
const sliceTypesOrder: Record<string, number> = {
  [SliceType.VARIABLE]: 1,
  [SliceType.SMART_LINK]: 2,
  [SliceType.URL]: 3,
  [SliceType.TEXT_COLOR]: 12,
}

const getSliceOrder = (slice: ISlice) => {
  if (slice.type && slice.type in sliceTypesOrder) {
    return sliceTypesOrder[slice.type]
  }
  return sliceOrderDefault
}

export const sortSlicesByType = (a: ISlice, b: ISlice) => {
  return getSliceOrder(b) - getSliceOrder(a)
}

export const exportString = (state: IProcessorState): string => {
  let currentSlices: ISlice[] = []
  let currentText = ''
  let result = ''

  const exportSlices = (text: string, slices: ISlice[]): string => {
    const slice = slices.pop()
    if (!slice) {
      return text
    }

    return exportSlices(exportSlice(text, slice), slices)
  }

  const flush = () => {
    result += exportSlices(currentText, currentSlices.sort(sortSlicesByType))
    currentText = ''
  }

  const text = textProcessorSelectors.getText(state)

  for (let i = 0; i < text.length; i++) {
    const nextSlices = textProcessorSelectors.getSlicesAt(state, i)
    if (!sliceArraysEqual(currentSlices, nextSlices)) {
      flush()
      currentSlices = nextSlices
    }
    currentText += text[i]
  }

  flush()

  return result
}
